module.exports = __webpack_public_path__ + "img/f4.4b66efd6.jpg";